// Styles for SuitesFilterPanel go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledSuitesFilterPanel = styled.div`
  .toggle-controls-list__toggle {
    width: 100%;
    max-width: 100%;
    flex: unset;
    padding-left: ${toRem(4)};
    padding-bottom: 0 !important;
  }

  .toggle-switch-wrapper {
    justify-content: space-between;
    flex-direction: row-reverse;
  }

  input[type='checkbox']:checked + .toggle-slider {
    background-color: ${contextualVariable.progressTrackerItemCompletedBgColor} !important;
    border-color: ${contextualVariable.progressTrackerItemCompletedBgColor} !important;
  }

  .brand-logo-container {
    width: ${toRem(126)};
    min-width: ${toRem(126)};
    margin: 0 ${toRem(16)} ${toRem(16)} 0;
    @media only ${baseVariables.mediaQuery.md} {
      width: ${toRem(150)};
      min-width: ${toRem(150)};
    }
  }

  .filter-separator {
    color: ${baseVariables.color['neutral30']};
    opacity: 0.5;
    margin-top: ${toRem(24)} !important;
    margin-bottom: 0 !important;
    &:first-child {
      margin-top: ${toRem(8)} !important;
    }
  }
  .toggle-controls-list,
  .brand-filter,
  .checkbox-controls-list,
  .radio-controls-list {
    padding: 0 !important;
  }
  fieldset > div:first-of-type {
    margin-top: ${toRem(24)} !important;
    margin-bottom: ${toRem(16)} !important;
  }

  .radio-controls-list__radio {
    padding-left: ${toRem(6)};
  }
  .checkbox-item {
    padding-left: ${toRem(8)};
    padding-bottom: ${toRem(8)};
  }
  .all-filters {
    padding: ${toRem(24)};
    @media only ${baseVariables.mediaQuery.tablet} {
      padding: ${toRem(32)};
    }
  }
  .brand-filter__title {
    margin-bottom: ${toRem(30)} !important;
    margin-top: 0 !important;
  }
  .brand-filter__category_list {
    margin-bottom: 0;
  }
  .clear {
    font-size: unset;
    color: ${contextualVariable.linkTextColor};
    padding: ${toRem(1)} 0;
  }
  .brand-filter {
    .filter-separator {
      margin-top: ${toRem(8)} !important;
    }
  }

  .toggle-controls-list {
    .filter-separator {
      margin-top: ${toRem(16)} !important;
    }
  }

  .modal-footer {
    padding: ${toRem(32)};
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    @media only ${baseVariables.mediaQuery.md} {
      border-bottom-right-radius: ${toRem(14)};
      border-bottom-left-radius: ${toRem(14)};
    }
  }
  .custom-scrollbar {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    @media only ${baseVariables.mediaQuery.md} {
      border-bottom-right-radius: ${toRem(14)};
      border-bottom-left-radius: ${toRem(14)};
    }
  }

  .modal-header {
    padding: ${toRem(24)};
    @media only ${baseVariables.mediaQuery.md} {
      padding: ${toRem(32)};
    }
  }

  .brand-filter__category_label_title {
    text-transform: uppercase;
  }

  .brand-filter__category_label {
    position: relative;
  }

  .brand-filter__category_label_btn {
    position: absolute;
    right: 0;
  }

  .show-more-btn:focus-visible,
  .clear:focus-visible {
    outline: -webkit-focus-ring-color auto ${toRem(1)};
  }

  .toggle-switch .checkbox-input {
    clip: unset;
    margin-top: ${toRem(1)};
    height: ${toRem(30)};
    width: ${toRem(50)};
    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }
`;
